/* unplugin-vue-components disabled */import { render } from "./protocol.vue?vue&type=template&id=56a7f4ac&scoped=true"
import script from "./protocol.vue?vue&type=script&lang=js"
export * from "./protocol.vue?vue&type=script&lang=js"

import "./protocol.vue?vue&type=style&index=0&id=56a7f4ac&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a7f4ac"]])

export default __exports__